'use client';
import PFLink from '@/components/PFLink';

const topicHrefRegExp = /\/thema\/([^\/]+)\/?.{0,}/;
const articleHrefRegExp = /\/news\/(\d+)\/(\d+)\/(\d+)\/(.+?).html\/?.{0,}/;

function hadnleOnClick(href: string) {
  if (topicHrefRegExp.test(href)) {
    const result = topicHrefRegExp.exec(href);

    if (result) {
      const [_, topic] = result;
      window.dataLayer?.push({
        event: 'custom_event',
        event_name: 'click_internal',
        click_internal: {
          link_url: href,
          link_type: 'theme',
          selected_theme: topic,
        },
      });
    }
  } else if (articleHrefRegExp.test(href)) {
    const result = articleHrefRegExp.exec(href);

    if (result) {
      const [, year, month, day, slug] = result;

      window.dataLayer?.push({
        event: 'custom_event',
        event_name: 'click_internal',
        click_internal: {
          link_url: href,
          link_type: 'article',
        },
      });
    }
  }
}

export function ParagraphLink({ children, href }) {
  return (
    <PFLink dataGoogleInterstitial onClick={hadnleOnClick} href={href}>
      {children}
    </PFLink>
  );
}
